import { $api } from '../y/api';
import { EPaymentIntent } from './e-payment-intent';
import { PGiftcardPlans } from './p-giftcard';

export function pGiftcardCheck(code: string) {
    return $api.POST('giftcards/check/' + code);
}

export function pGiftcardPlansGet() {
    return $api.POST<PGiftcardPlans>('giftcards/plans', { codes: window.tl_codes, default_country: window.tl_default_country });
}

export function pGiftcardPlansWithCode(code: string) {
    return $api.POST<PGiftcardPlans>('giftcards/plans', { codes: [code], default_country: window.tl_default_country });
}

export function pGiftcardBuy(data: any) {
    return $api.POST<EPaymentIntent>('p/giftcards/buy', data);
}

export function pGiftcardB2B(data: any) {
    return $api.POST('giftcards/b2b', data);
}

